import { getImportedAccountConnectionTaskTitle } from "@common/helpers/importedAccountConnectionTaskTitle";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { CheckIcon, TasksIcon } from "@icons";
import { AccountRow } from "./types";
import styles from "./MapImportedAccountsSpreadsheet.module.scss";

interface Props {
    row: Pick<
        AccountRow,
        | "kickAccountId"
        | "createNewAccount"
        | "accountConnectionTaskId"
        | "financialType"
        | "detectedInstitutionName"
    >;
}

export const AccountMappingStatus: React.FC<Props> = ({ row }) => {
    if (row.kickAccountId && !row.createNewAccount) {
        return (
            <span className={styles.mappedStatus}>
                <CheckIcon className="icon-color-current" />
                Mapped
            </span>
        );
    }

    if (row.accountConnectionTaskId) {
        return (
            <span className={styles.mappedStatus}>
                <TasksIcon className="icon-color-current" />
                Task created
            </span>
        );
    }

    if (row.createNewAccount) {
        return (
            <Tooltip content="Created as a new Kick account when the mapping is confirmed.">
                <span className={styles.mappedStatus}>
                    <CheckIcon className="icon-color-current" />
                    New account
                </span>
            </Tooltip>
        );
    }

    if (row.financialType && !row.kickAccountId) {
        const taskTitle = getImportedAccountConnectionTaskTitle({
            detectedInstitutionName: row.detectedInstitutionName,
        });
        return (
            <Tooltip
                content={
                    <>
                        After you confirm the mapping, follow the instructions
                        in the <strong>{taskTitle}</strong> task to connect this
                        financial account.
                    </>
                }
            >
                <span className={styles.mappedStatus}>
                    <TasksIcon className="icon-color-current" />
                    Connect in Tasks
                </span>
            </Tooltip>
        );
    }

    return null;
};
